/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as t from "react";
import { createFilterComponent as o } from "./FilterComponent.mjs";
import { DropDownList as r } from "@progress/kendo-react-dropdowns";
import { NumericTextBox as m } from "@progress/kendo-react-inputs";
const n = {
  inputComponent: (e) => /* @__PURE__ */ t.createElement(m, { ...e }),
  operatorComponent: (e) => /* @__PURE__ */ t.createElement(r, { ...e }),
  emptyFilter: { operator: "eq", value: null }
};
class a extends o(n) {
}
export {
  a as NumericFilterCell
};
